import { useTranslation } from 'react-i18next'

import type { DockWidth } from './useDockWidth'

/**
 * The dock's left edge, as a separator you can drag or step with ← / →. Hidden below md, where the
 * dock is a full-width overlay with nothing beside it to give room to.
 */
export function DockResizeHandle({ width, min, max, resizing, onResizeStart, onResizeKey }: DockWidth) {
  const { t } = useTranslation('console')

  return (
    <div
      role="separator"
      aria-orientation="vertical"
      aria-label={t('assistant.panel.resize', 'Resize assistant')}
      aria-valuenow={width}
      aria-valuemin={min}
      aria-valuemax={max}
      tabIndex={0}
      data-testid="assistant-dock-resize"
      onPointerDown={onResizeStart}
      onKeyDown={onResizeKey}
      style={{ touchAction: 'none' }}
      className={`absolute inset-y-0 left-0 z-10 hidden w-1.5 cursor-col-resize hover:bg-primary-500/30 focus:outline-none focus-visible:bg-primary-500/40 md:block ${
        resizing ? 'bg-primary-500/40' : ''
      }`}
    />
  )
}
